import { useState } from 'react';
import { Avatar, IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import LogoutRounded from '@mui/icons-material/LogoutRounded';
import type { UserShape } from './useAuthShell';

type Props = {
  user: UserShape;
  avatarInitial: string;
  go: (path: string) => void;
  onLogout: () => void;
  size?: number;
};

const UserMenu = ({ user, avatarInitial, go, onLogout, size = 34 }: Props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClose = () => setAnchorEl(null);
  const item = (fn: () => void) => () => {
    handleClose();
    fn();
  };

  return (
    <>
      <Tooltip title="Account">
        <IconButton onClick={(e) => setAnchorEl(e.currentTarget)} size="small">
          <Avatar sx={{ width: size, height: size }}>{avatarInitial}</Avatar>
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem disabled>{user?.fullName || 'User'}</MenuItem>
        <MenuItem onClick={item(() => go('/profile'))}>My Profile</MenuItem>
        <MenuItem onClick={item(() => go('/settings'))}>Settings</MenuItem>
        <MenuItem onClick={item(onLogout)}>
          <LogoutRounded fontSize="small" sx={{ mr: 1 }} /> Logout
        </MenuItem>
      </Menu>
    </>
  );
};

export default UserMenu;
